import { ConsentString } from 'consent-string';
import { loadGdprAdConsentString } from 'owa-gdpr-ad-consent-string';
import { isGdprAdMarket } from 'owa-mail-ads-shared';

export default async function processGetVendorConsentsCommand(
    vendorIds: number[],
    onCallback: any
): Promise<void> {
    const gdprAppliesToUser = isGdprAdMarket();

    const consent = {
        metadata: '',
        gdprApplies: gdprAppliesToUser,
        hasGlobalScope: true,
        cmpId: null,
        cmpVersion: null,
        consentLanguage: null,
        consentScreen: null,
        cookieVersion: null,
        globalVendorListVersion: undefined,
        maxVendorId: null,
        publisherVendorsVersion: undefined,
        vendorListVersion: null,
        purposeConsents: null,
        vendorConsents: null,
        created: null,
        lastUpdated: null,
    };

    if (gdprAppliesToUser) {
        const consentDataString = await loadGdprAdConsentString();

        const consentDataEncodedString = new ConsentString(consentDataString);

        // TODO: The following values are retrieved based on our current understanding, need to double check with AppNexus to see if it is right
        // before it goes online. Currently, the AppNexus ast file does not call this function
        consent.metadata = consentDataString;
        consent.cmpId = consentDataEncodedString.getCmpId();
        consent.cmpVersion = consentDataEncodedString.getCmpVersion();
        consent.consentLanguage = consentDataEncodedString.getConsentLanguage();
        consent.consentScreen = consentDataEncodedString.getConsentScreen();
        consent.vendorListVersion = consentDataEncodedString.getVendorListVersion();
        consent.purposeConsents = consentDataEncodedString.getPurposesAllowed();
        consent.vendorConsents = consentDataEncodedString.getVendorsAllowed();
        consent.cookieVersion = consentDataEncodedString.getVersion();
    }

    onCallback(consent, true);
    Promise.resolve();
}
